import type { DriverRow } from "@/types/driver";

/**
 * The Google Maps search page for a point, in a new tab.
 */
export function googleMapsUrl(latitude: number, longitude: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
}

/**
 * What the roster, the Dispatch table and the context panel show for a driver's location.
 *
 * The place name its source gave; else the municipality and region the store composes; else the coordinates to four
 * decimals, flagged so a surface can link them to a map; else null.
 */
export function locationText(
  row: Pick<DriverRow, "locationPlaceName" | "location" | "latitude" | "longitude">,
): { text: string; coordinates: boolean } | null {
  if (row.locationPlaceName) return { text: row.locationPlaceName, coordinates: false };
  if (row.location) return { text: row.location, coordinates: false };
  if (row.latitude == null || row.longitude == null) return null;
  return { text: `${row.latitude.toFixed(4)}, ${row.longitude.toFixed(4)}`, coordinates: true };
}
